// extracted by mini-css-extract-plugin
export default {"framework-selector":"X_cd d-flex","framework-selector__icon":"X_cf","framework-selector__option":"X_cg p-2 flex-grow-1 ml-2","framework-selector__option--selected":"X_ch"};